import React from 'react';
import { Link } from 'react-router-dom';
import PageWrapper from '../../components/page-wrapper/page-wrapper';

const Unauthorized = () => {
  return (
    <PageWrapper>
      <div className="container mt-5 pt-5">
        <div className="row justify-content-center">
          <div className="col-md-8 text-center">
            <div className="alert alert-danger">
              <h2>Unauthorized Access</h2>
              <p className="lead">
                You do not have permission to access this page. This area is restricted to administrators only.
              </p>
              <hr />
              <p>
                If you believe you should have access to this page, please contact the site administrator.
              </p>
              <Link to="/" className="btn btn-primary mt-3">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default Unauthorized;